/* eslint-disable no-undef */
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/index';
import VueLazyload from 'vue-lazyload';
import infiniteScroll from 'vue-infinite-scroll';
import QcVue from '@tencent/qcvue2';
import EbUi from '../packages/EbUi/index';
import ElementUI from 'element-ui';
import axios from './lib/axios';
import fetch from './lib/fetch';
import CommonDialogue from '@/components/commonDialogue/index';
import CommonDialogueNew from '@/components/CommonDialogueNew/index';
import navigator from '@/lib/navigator';
import directive from '@/common/directive';
import aegis from '@/utils/aegis';
// 全局样式
import './common/style/global.less';
// element 主题样式
import '@/common/style/element-variables.scss';
// qc 样式
import '@tencent/qcvue2/dist/qcvue.css';
// reset ui 组件库
import './common/style/reset.less';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false;
const webConfigMixin = {
  data() {
    const { WEB_NAME, LOGO_NAME } = WEB_CONFIG; // WEB_CONFIG, webpack 构建的全局Object

    return {
      WEB_CONFIG,
      WEB_NAME,
      LOGO_NAME,
    };
  },
};
Vue.mixin(webConfigMixin);
Vue.use(VueClipboard);
Vue.use(QcVue);
Vue.use(EbUi);
Vue.use(ElementUI);
Vue.use(infiniteScroll);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
});
Vue.use(CommonDialogue);
Vue.use(CommonDialogueNew);
Vue.use(navigator);
Vue.use(directive);

// 测试环境需要引入的模块，请在此按需异步加载
if (process.env.NODE_ENV === 'development') {
  import('vconsole')
    .then(({ default: VConsole }) => {
      new VConsole();
    });
}
if (process.env.NODE_ENV === 'production') {
  aegis.init();
}

Vue.prototype.$ajax = axios;
Vue.prototype.$fetch = fetch;

const Page = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

window.Page = Page;
window.$router = router;

// 运行时延迟加载小满sdk
window.addEventListener('load', () => {
  const isDevEnv = process.env.NODE_ENV === 'development';
  const xiaomanAppid = isDevEnv ? '26087194' : '50169734';
  const script = document.createElement('script');
  script.setAttribute('src', 'https://xiaoman.woa.com/assets/grade.min.js');
  script.setAttribute('appid', xiaomanAppid);
  document.body.appendChild(script);
});
